import styled from '@emotion/styled';
import MEDIA_QUERY from '@zola/zola-ui/src/styles/emotion/mediaQuery';
import { VERTICAL_NAV_WIDTH } from 'hooks/useIsPostAuthNav3Active';

export const PageContainer = styled.div<{
  isGuest: boolean;
}>`
  max-width: 1920px;
  margin-left: auto;
  margin-right: auto;
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    scroll-margin-top: 150px;
  }
  ${MEDIA_QUERY.DESKTOP} {
    ${({ isGuest }) => (isGuest ? null : `margin-left: ${VERTICAL_NAV_WIDTH}px;`)}
  }
`;
